module.exports = require("cwise-compiler")